export const STATUSES = {
  pending: {
    bgColor: 'Background-Notice',
    color: 'Interface-Orange-Secondary',
    icon: 'time-clock',
  },
  repaid: {
    bgColor: 'Background-Confirm',
    color: 'Label-Confirm',
    icon: 'status active',
  },
  declined: {
    bgColor: 'Background-Error',
    color: 'Label-Error-Primary',
    icon: 'status warning',
  },
  approved: {
    bgColor: 'Background-Fifth',
    color: 'Label-GU-Primary',
    icon: 'status active',
  },
  expired: {
    bgColor: 'Background-Error',
    color: 'Label-Error-Primary',
    icon: 'status warning',
  },
}
